<div *ngFor="let banner of bannerConfigs">
  <div class="banner" 
    *ngIf="showBanner(banner)"
    [style.backgroundColor]="banner.backgroundcolor"
    [style.color]="banner.fontcolor">

    <div [innerHTML]="banner.safe"></div>

  </div>
</div>